'use strict';

const primitives = require("./primitives");
const HEXColor = primitives.HEXColor, SportTeamInfo = primitives.SportTeamInfo;

exports.combinedRepresenter = function(...theRepresenters) {
  const representers = Array.from(theRepresenters);
  const encoders = representers.map(r => r.encode.bind(r));
  const decoders = representers.map(r => r.decode.bind(r)).reverse();
  return {
    encode(value) {
      return encoders.reduce((res, encoder) => {
        return encoder(res);
      }, value);
    },
    decode(snapshot) {
      return decoders.reduce((res, decoder) => {
        return decoder(res);
      }, snapshot);
    }
  };
}

exports.valueRepresenter = function(required) {
  return {
    encode(value) {
      if (required && (value === undefined || value === null)) {
        throw Error("Cannot encode empty value");
      }
      return value;
    },
    decode(snapshot) {
      if (required && !snapshot.exists()) {
        throw Error("Cannot decode empty value");
      }
      return snapshot.val();
    }
  };
}
exports.propsRepresenter = function(objClass) {
  return {
    encode(value) {
      return value;
    },
    decode(snapshot) {
      return new objClass.prototype.constructor(snapshot.val());
    }
  };
}
exports.anywayRepresenter = function(defValue) {
  return {
    encode(value) {
      return value == defValue ? null : value;
    },
    decode(snapshot) {
      return snapshot.exists() ? snapshot.val() : defValue;
    }
  };
}
exports.defaultValue = function(base, defVal) {
  // TODO: defVal must be function
  return {
    encode(value) {
      return value === undefined || value == defVal ? null : base.encode(value);
    },
    decode(snapshot) {
      return snapshot.exists() ? base.decode(snapshot) : defVal;
    }
  };
}
const hexColorRepresenter = {
  get alphaSpace() {
    return 0xff << 24;
  },
  encode(hexColor) {
    return hexColor.value | ((hexColor.alpha * 100) << 24);
  },
  decode(snapshot) {
    const hexColor = snapshot.val();
    const value = hexColor & ~this.alphaSpace;
    const alpha = ((hexColor & this.alphaSpace) >> 24) / 100;
    return new HEXColor(value, alpha);
  }
};
exports.hexColorRepresenter = hexColorRepresenter;
exports.teamInfoRepresenter = {
  encode(value) {
    return Object.keys(value).reduce((res, key) => {
      if (key == "colors") {
        const colors = value[key];
        res[key] = colors
          ? {
              first: hexColorRepresenter.encode(colors.first),
              second: hexColorRepresenter.encode(colors.second)
            }
          : null;
      }
      return res;
    }, {});
  },
  decode(snapshot) {
    if (snapshot.hasChild("colors")) {
      const colors = snapshot.child("colors");
      return new SportTeamInfo({
        colors: {
          first: hexColorRepresenter.decode(colors.child("first")),
          second: hexColorRepresenter.decode(colors.child("second"))
        }
      });
    }
    return null;
  }
};
